module.exports = __webpack_public_path__ + "static/media/tela-passo-05.4441adeb.jpg";